import { useEffect, useState } from 'react';
import Footer from '../../Components-2/Footer';
import Header from '../../Components-2/Header/Header';
import Sidebar1 from '../../Components-2/Sidebar1';
import { useLocation } from 'react-router-dom';
import FuturePaymentRec from './FuturePaymentRec';
import AddPayment from './AddPayment';
import Purchase from './Purchase';

function PayTabs() {
  const location = useLocation();

  // Get user permissions
  const permissions = JSON.parse(localStorage.getItem("Login")) || {};
  const has = (key) => permissions[key] === 1;

  // Define tabs with permissions
  const tabs = [
    { id: 'pay', label: 'Add Payment', component: <AddPayment/>, permission: 1 },
    { id: 'rec', label: 'Payment Received', component: <FuturePaymentRec/>, permission: 1 },
    { id: 'pur', label: 'Purchase Voucher', component: <Purchase/>, permission: 1 },
  ];

  // Filter tabs based on permissions
  const visibleTabs = tabs.filter(tab => tab.permission);

  const [activeTab, setActiveTab] = useState(location?.state?.tab || visibleTabs[0]?.id || null);

  useEffect(() => {
    if (!activeTab && visibleTabs.length > 0) {
      setActiveTab(visibleTabs[0].id);
    }
  }, [visibleTabs, activeTab]);

  return (
    <>
      <Header />
      <Sidebar1 />
      <div id="main-body">
        <div className="container">
          {/* Navigation Tabs */}
          <nav style={{ height: "28px" }}>
            {visibleTabs.map(tab => (
              <label
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </label>
            ))}

            {/* Slider */}
            <div
              className="slider"
              style={{
                left: `${visibleTabs.findIndex(t => t.id === activeTab) * (100 / visibleTabs.length)}%`,
                width: `${100 / visibleTabs.length}%`,
              }}
            />
          </nav>

          {/* Dynamic Tab Content */}
          <section>
            {visibleTabs.find(t => t.id === activeTab)?.component}
          </section>
        </div>

        <Footer />
      </div>
    </>
  );
}

export default PayTabs;
